var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('room-video', _vm._b({}, 'room-video', {
    stream: _vm.stream,
    enabled_audio: _vm.enabled_audio,
    enabled_video: _vm.enabled_video
  }, false));

}
var staticRenderFns = []

export { render, staticRenderFns }